import { create } from "zustand";

import { MainReportInterface } from "./interface/main-report.interface";
import { EnumReportScope, QueryMainReport, QuerySummarizeMainReport } from "src/entity/main-report/main-report.entity";
import {
  getDistinctYearDropdown,
  getMainReport,
  getMainReportForCharts,
  getMainReportOverviews,
  getSummarizeMainReport,
} from "src/services/main-report.service";

export const mainReportStore = create<MainReportInterface>((set) => ({
  loading: false,
  data: [],
  dataYearly: [],
  dataOverviews: {
    annualVocsTarget: "0",
    vocsIntensityTarget2030: "0",
    vocsIntensity: "0",
    vocsEmission: "0",
  },

  loadingChartYear: false,
  loadingChartMonth: false,
  dataCharts: [],
  dataChartsYearly: [],
  loadingOverviews: false,
  error: "",
  loadingDistinctYear: false,
  dataDistinctYear: [],

  loadingSummarizeReport: false,
  dataSummarizeReport: [],
  errorSummarizeReport: null,
  getMainReport: async (query: QueryMainReport) => {
    set(() => ({ loading: true }));
    try {
      const res = await getMainReport(query);
      if (query.scope === EnumReportScope.MONTHLY) set(() => ({ loading: false, data: res.data?.data || [] }));
      else set(() => ({ loading: false, dataYearly: res.data?.data || [] }));
    } catch (err: any) {
      console.error(err);
      set(() => ({ loading: false, error: err?.message || "", data: [], dataYearly: [] }));
    }
  },
  getMainReportOverviews: async (query: QueryMainReport) => {
    set(() => ({ loadingOverviews: true }));
    try {
      const res = await getMainReportOverviews(query);
      set(() => ({ loadingOverviews: false, dataOverviews: res.data?.data }));
    } catch (err: any) {
      console.error(err);
      set(() => ({
        loadingOverviews: false,
        dataOverviews: { annualVocsTarget: "0", vocsIntensityTarget2030: "0", vocsIntensity: "0", vocsEmission: "0" },
      }));
    }
  },
  getMainReportCharts: async (query: QueryMainReport) => {
    set(() => (query.scope === EnumReportScope.MONTHLY ? { loadingChartMonth: true } : { loadingChartYear: true }));
    try {
      const res = await getMainReportForCharts(query);
      if (query.scope === EnumReportScope.MONTHLY) set(() => ({ loadingChartMonth: false, data: res.data?.data || [] }));
      else set(() => ({ loadingChartYear: false, dataYearly: res.data?.data || [] }));
    } catch (err: any) {
      console.error(err);
      set(() => ({
        error: err?.message || "",
        data: [],
        dataYearly: [],
        ...(query.scope === EnumReportScope.MONTHLY ? { loadingChartMonth: true } : { loadingChartYear: true }),
      }));
    }
  },
  getSummarizeMainReport: async (query: QuerySummarizeMainReport) => {
    set(() => ({ loadingSummarizeReport: true }));
    try {
      const res = await getSummarizeMainReport(query);
      // console.log("API Summarize response : ", res.data);
      set(() => ({ loadingSummarizeReport: false, dataSummarizeReport: res.data?.data || [] }));
    } catch (err: any) {
      console.error(err);
      set(() => ({ loadingSummarizeReport: false, error: err?.message || "", dataSummarizeReport: [] }));
    }
  },

  getDistinctYearDropdown: async () => {
    set(() => ({ loadingDistinctYear: true }));
    try {
      const res = await getDistinctYearDropdown();
      set(() => ({ loadingDistinctYear: false, dataDistinctYear: res.data?.data || [] }));
    } catch (err: any) {
      console.error(err);
      set(() => ({ loadingDistinctYear: false, dataDistinctYear: [] }));
    }
  },
}));
